import { render, staticRenderFns } from "./medicineDetailModal.vue?vue&type=template&id=1f550df5"
import script from "./medicineDetailModal.vue?vue&type=script&lang=js"
export * from "./medicineDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports